var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntitySummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ECE8F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18066 9.5487C11.1279 8.83151 13.2935 8.81793 15.25 9.50475V23.0057L14.3857 22.6883C13.0338 22.1905 11.5238 22.1904 10.1719 22.6883C9.17771 23.0545 8.00016 22.3982 8 21.2919V11.1747C8.00034 10.4395 8.48522 9.80488 9.18066 9.5487ZM16.75 9.50475C18.7064 8.81816 20.8723 8.83159 22.8193 9.5487C23.5146 9.80495 23.9997 10.4396 24 11.1747V21.2919C23.9998 22.3981 22.8222 23.0543 21.8281 22.6883C20.476 22.1904 18.9654 22.1904 17.6133 22.6883L16.75 23.0057V9.50475Z",
    fill: "#441A98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitySummary);
export default __webpack_public_path__ + "static/media/entity_summary.4a70917b6da2bc8bec538e0c442a5774.svg";
export { ForwardRef as ReactComponent };